
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"#939393","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.324 4.378c2.282.177 4.154 1.957 4.38 4.176a4.56 4.56 0 01-.838 3.14l-.06.074-7.05 7.5c-.382.485-1.129.485-1.484.034l-7.125-7.59-.067-.097a4.556 4.556 0 01-.778-3.106c.243-2.198 2.105-3.953 4.37-4.13 1.738-.134 3.365.64 4.328 1.988.96-1.346 2.587-2.12 4.324-1.989zm-11.321 6.72l6.995 7.447 6.96-7.4a3.53 3.53 0 00.66-2.443c-.174-1.71-1.634-3.099-3.409-3.236-1.43-.108-2.758.564-3.488 1.712a.86.86 0 01-1.443 0c-.73-1.15-2.06-1.822-3.49-1.712-1.763.138-3.214 1.506-3.402 3.2a3.512 3.512 0 00.595 2.393l.022.04z"}})])
          )
        }
      }
    